import React, { useState, useEffect } from 'react'
import { PaginationControl } from "react-bootstrap-pagination-control";
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { Link } from 'react-router-dom'
import { Get, Delete } from '../../web_api/api'

export default function Main() {

    const [dataCount, setDataCount] = useState("");
    const [page, setPage] = useState(1)
    const [blogList, setBlogList] = useState([])
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    //for pagination 
    const paginationItems = React.useMemo(() => {
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage;
        return blogList.slice(start, end);
    }, [page, blogList]);

    // to delete list's item
    const handleDelete = async (event) => {
        await Delete('/blog/', event)
        const result = blogList.filter(item => item._id !== event)
        setBlogList(result)
    }

    useEffect(() => {
        const getBlogs = async () => {
            const res = await Get('blogs')
            // console.log(res, 'blog')
            setBlogList(res.data)
            setDataCount(res.data.length)


        }
        getBlogs()

    }, [])
    return (
        <div>
            <div className='row'>
                <div className='content-wrapper w-75'>
                    {/* <!-- Content Header (Page header) --> */}
                    <div className='content-header'>
                        <div className='container-fluid'>
                            <div className='row mb-2'>
                                <div className='col-sm-12'>
                                    <ol className='breadcrumb'>
                                        <li className='breadcrumb-item active'>Treatment List</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- Main content --> */}
                    <section class='content'>
                        <div class='container-fluid'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='card'>
                                        <Link to='/treatment-create' className='card-header'>
                                            {/* <h3 className="card-title">Currency List</h3> */}

                                            <button
                                                type='button'

                                                className='btn btn-sm btn-primary float-right'
                                            >
                                                <i className='fa fa-plus'></i> &nbsp;Add
                                            </button>
                                        </Link>
                                        <div className='card-body'>
                                            <table className='table table-hover mt-4'>
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Treatment Name</th>
                                                        <th>Type</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paginationItems.map((blog, i) => (
                                                        <tr key={i}>
                                                            <td>{++i}</td>
                                                            <td>{blog.name}</td>

                                                            <td>{blog.type ? (blog.type === 'face' ? 'Face & Skin' : (blog.type === 'body' ? 'Body Contouring' : 'Dental Care')) : ''}</td>
                                                            <td>
                                                                <IconButton
                                                                    aria-label='delete'
                                                                    onClick={() => handleDelete(blog._id)}
                                                                >
                                                                    <DeleteIcon className='text-danger' />
                                                                </IconButton>
                                                                <Link to={'/treatment-update/' + blog._id}>
                                                                    <IconButton aria-label='edit'>
                                                                        <EditIcon className='text-warning' />
                                                                    </IconButton>
                                                                </Link>

                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className='mt-4'>
                                            <PaginationControl
                                                page={page}
                                                between={4}
                                                total={dataCount}
                                                limit={10}
                                                changePage={(page) => {
                                                    setPage(page);
                                                }}
                                                ellipsis={1}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>
            </div>

        </div>

    )
}





